export const enum SnShareDirection {
  In = 'In',
  Out = 'Out',
}
